import { Col, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const boxData = [
  {
    title: "Total Cities",
    valueKey: "city",
    navigateTo: "/city",
    headingClass: "boxHeadingRisk fw-600",
    textClass: "priceText color-risk",
  },
  {
    title: "Total Areas",
    valueKey: "area",
    navigateTo: "/area",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
  {
    title: "Total Occasions",
    valueKey: "totalOccasion",
    navigateTo: "/occasion",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
  {
    title: "Total Functions",
    valueKey: "function",
    navigateTo: "/occasion-functions", // No navigation for this box
    headingClass: "boxHeadingRisk fw-600",
    textClass: "priceText color-risk",
  },
  {
    title: "Total Essentials",
    valueKey: "functionEss",
    navigateTo: "/function-essentials",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
  {
    title: "Total Essential Types",
    valueKey: "essType",
    navigateTo: "/essential-types",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
 {
  title: "Total Users",
  valueKey: "user",
  navigateTo: "/users",
  headingClass: "boxHeadingTotal fw-600",
  textClass: "priceText",
},

  {
    title: "Total Orders",
    valueKey: "order",
    navigateTo: "/orders",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
  {
    title: "Total Gallery",
    valueKey: "gallery",
    navigateTo: "/gallery",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
  {
    title: "Total YouTube",
    valueKey: "youtube",
    navigateTo: "/youtube",
    headingClass: "boxHeadingTotal fw-600",
    textClass: "priceText",
  },
];

const Boxes = () => {
  const navigate = useNavigate();
  const dashboard = useSelector((state) =>
    state?.allApi?.dashboard ? state?.allApi?.dashboard : {}
  );

  return (
    <Row gutter={[20, 20]}>
      {boxData.map((box, index) => (
        <Col
          key={index} xs={24} sm={24} md={12} lg={8} xl={8}
        >
          <div
            className="flex1 p-10 dashboardBox cursor-pointer"
            style={{
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Add shadow effect
             // border: "none", // Remove border
              borderRadius: "8px", // Optional: Add rounded corners
              backgroundColor: "#fff", // Optional: Ensure background is white for better shadow visibility
            }}
            onClick={() => box.navigateTo && navigate(box.navigateTo)} // Navigate only if navigateTo is provided
          >
            <div className="flex justify-content-between align-item-center">
              <div className={`relative ${box.headingClass}`}>
                {box.title}
              </div>
            </div>
            <div className="flex justify-content-end align-item-center">
              <div className={box.textClass}>
                {dashboard?.[box.valueKey] || 0}
              </div>
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default Boxes;